import { render, staticRenderFns } from "./NormalSearchNav691.vue?vue&type=template&id=b4a7c2c6&scoped=true&"
import script from "./NormalSearchNav691.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav691.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a7c2c6",
  null
  
)

export default component.exports